// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * ==============================================
 * Dot Elastic
 * ==============================================
 */
.dot-elastic {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-elastic 1s infinite linear;
}
.dot-elastic::before, .dot-elastic::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-elastic::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-elastic-before 1s infinite linear;
}
.dot-elastic::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-elastic-after 1s infinite linear;
}

@keyframes dot-elastic-before {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1.5);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes dot-elastic {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 1.5);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}
@keyframes dot-elastic-after {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 0.67);
  }
  75% {
    transform: scale(1, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
}
/**
 * ==============================================
 * Dot Pulse
 * ==============================================
 */
.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  box-shadow: 9999px 0 0 -5px;
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;
}
.dot-pulse::before, .dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
}
.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px;
  animation: dot-pulse-before 1.5s infinite linear;
  animation-delay: 0s;
}
.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px;
  animation: dot-pulse-after 1.5s infinite linear;
  animation-delay: 0.5s;
}

@keyframes dot-pulse-before {
  0% {
    box-shadow: 9984px 0 0 -5px;
  }
  30% {
    box-shadow: 9984px 0 0 2px;
  }
  60%, 100% {
    box-shadow: 9984px 0 0 -5px;
  }
}
@keyframes dot-pulse {
  0% {
    box-shadow: 9999px 0 0 -5px;
  }
  30% {
    box-shadow: 9999px 0 0 2px;
  }
  60%, 100% {
    box-shadow: 9999px 0 0 -5px;
  }
}
@keyframes dot-pulse-after {
  0% {
    box-shadow: 10014px 0 0 -5px;
  }
  30% {
    box-shadow: 10014px 0 0 2px;
  }
  60%, 100% {
    box-shadow: 10014px 0 0 -5px;
  }
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.dot-flashing::before, .dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-flashing::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.dot-flashing::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dot-flashing {
  0% {
    background-color: #b9c0e9;
  }
  50%, 100% {
    background-color: rgba(185, 192, 233, 0.2);
  }
}
/**
 * ==============================================
 * Dot Collision
 * ==============================================
 */
.dot-collision {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
}
.dot-collision::before, .dot-collision::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-collision::before {
  left: -10px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-collision-before 2s infinite ease-in;
}
.dot-collision::after {
  left: 10px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-collision-after 2s infinite ease-in;
  animation-delay: 1s;
}

@keyframes dot-collision-before {
  0%, 50%, 75%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-15px);
  }
}
@keyframes dot-collision-after {
  0%, 50%, 75%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(15px);
  }
}
/**
 * ==============================================
 * Dot Revolution
 * ==============================================
 */
.dot-revolution {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
}
.dot-revolution::before, .dot-revolution::after {
  content: "";
  display: inline-block;
  position: absolute;
}
.dot-revolution::before {
  left: 0;
  top: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  transform-origin: 5px 20px;
  animation: dot-revolution 1.4s linear infinite;
}
.dot-revolution::after {
  left: 0;
  top: -30px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  transform-origin: 5px 35px;
  animation: dot-revolution 1s linear infinite;
}

@keyframes dot-revolution {
  0% {
    transform: rotateZ(0deg) translate3d(0, 0, 0);
  }
  100% {
    transform: rotateZ(360deg) translate3d(0, 0, 0);
  }
}
/**
 * ==============================================
 * Dot Carousel
 * ==============================================
 */
.dot-carousel {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  animation: dot-carousel 1.5s infinite linear;
}

@keyframes dot-carousel {
  0% {
    box-shadow: 9984px 0 0 -1px #b9c0e9, 9999px 0 0 1px #b9c0e9, 10014px 0 0 -1px #b9c0e9;
  }
  50% {
    box-shadow: 10014px 0 0 -1px #b9c0e9, 9984px 0 0 -1px #b9c0e9, 9999px 0 0 1px #b9c0e9;
  }
  100% {
    box-shadow: 9999px 0 0 1px #b9c0e9, 10014px 0 0 -1px #b9c0e9, 9984px 0 0 -1px #b9c0e9;
  }
}
/**
 * ==============================================
 * Dot Typing
 * ==============================================
 */
.dot-typing {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  animation: dot-typing 1.5s infinite linear;
}

@keyframes dot-typing {
  0% {
    box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  }
  16.667% {
    box-shadow: 9984px -10px 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  }
  33.333% {
    box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  }
  50% {
    box-shadow: 9984px 0 0 0 #b9c0e9, 9999px -10px 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  }
  66.667% {
    box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  }
  83.333% {
    box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px -10px 0 0 #b9c0e9;
  }
  100% {
    box-shadow: 9984px 0 0 0 #b9c0e9, 9999px 0 0 0 #b9c0e9, 10014px 0 0 0 #b9c0e9;
  }
}
/**
 * ==============================================
 * Dot Windmill
 * ==============================================
 */
.dot-windmill {
  position: relative;
  top: -10px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  transform-origin: 5px 15px;
  animation: dot-windmill 2s infinite linear;
}
.dot-windmill::before, .dot-windmill::after {
  content: "";
  display: inline-block;
  position: absolute;
}
.dot-windmill::before {
  left: -8.66254px;
  top: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
}
.dot-windmill::after {
  left: 8.66254px;
  top: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
}

@keyframes dot-windmill {
  0% {
    transform: rotateZ(0deg) translate3d(0, 0, 0);
  }
  100% {
    transform: rotateZ(720deg) translate3d(0, 0, 0);
  }
}
/**
 * ==============================================
 * Dot Bricks
 * ==============================================
 */
.dot-bricks {
  position: relative;
  top: 8px;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  box-shadow: 9991px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9;
  animation: dot-bricks 2s infinite ease;
}

@keyframes dot-bricks {
  0% {
    box-shadow: 9991px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9;
  }
  8.333% {
    box-shadow: 10007px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9;
  }
  16.667% {
    box-shadow: 10007px -16px 0 0 #b9c0e9, 9991px -16px 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9;
  }
  25% {
    box-shadow: 10007px -16px 0 0 #b9c0e9, 9991px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9;
  }
  33.333% {
    box-shadow: 10007px 0 0 0 #b9c0e9, 9991px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9;
  }
  41.667% {
    box-shadow: 10007px 0 0 0 #b9c0e9, 10007px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9;
  }
  50% {
    box-shadow: 10007px 0 0 0 #b9c0e9, 10007px -16px 0 0 #b9c0e9, 9991px -16px 0 0 #b9c0e9;
  }
  58.333% {
    box-shadow: 9991px 0 0 0 #b9c0e9, 10007px -16px 0 0 #b9c0e9, 9991px -16px 0 0 #b9c0e9;
  }
  66.666% {
    box-shadow: 9991px 0 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9, 9991px -16px 0 0 #b9c0e9;
  }
  75% {
    box-shadow: 9991px 0 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9, 10007px -16px 0 0 #b9c0e9;
  }
  83.333% {
    box-shadow: 9991px -16px 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9, 10007px -16px 0 0 #b9c0e9;
  }
  91.667% {
    box-shadow: 9991px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9, 10007px -16px 0 0 #b9c0e9;
  }
  100% {
    box-shadow: 9991px -16px 0 0 #b9c0e9, 9991px 0 0 0 #b9c0e9, 10007px 0 0 0 #b9c0e9;
  }
}
/**
 * ==============================================
 * Dot Floating
 * ==============================================
 */
.dot-floating {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-floating 3s infinite cubic-bezier(0.15, 0.6, 0.9, 0.1);
}
.dot-floating::before, .dot-floating::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-floating::before {
  left: -12px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-floating-before 3s infinite ease-in-out;
}
.dot-floating::after {
  left: -24px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-floating-after 3s infinite cubic-bezier(0.4, 0, 1, 1);
}

@keyframes dot-floating {
  0% {
    left: calc(-50% - 5px);
  }
  75% {
    left: calc(50% + 105px);
  }
  100% {
    left: calc(50% + 105px);
  }
}
@keyframes dot-floating-before {
  0% {
    left: -50px;
  }
  50% {
    left: -12px;
  }
  75% {
    left: -50px;
  }
  100% {
    left: -50px;
  }
}
@keyframes dot-floating-after {
  0% {
    left: -100px;
  }
  50% {
    left: -24px;
  }
  75% {
    left: -100px;
  }
  100% {
    left: -100px;
  }
}
/**
 * ==============================================
 * Dot Fire
 * ==============================================
 */
.dot-fire {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  box-shadow: 9999px 22.5px 0 -5px #b9c0e9;
  animation: dot-fire 1.5s infinite linear;
  animation-delay: -0.85s;
}
.dot-fire::before, .dot-fire::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
}
.dot-fire::before {
  box-shadow: 9999px 22.5px 0 -5px #b9c0e9;
  animation: dot-fire 1.5s infinite linear;
  animation-delay: -1.85s;
}
.dot-fire::after {
  box-shadow: 9999px 22.5px 0 -5px #b9c0e9;
  animation: dot-fire 1.5s infinite linear;
  animation-delay: -2.85s;
}

@keyframes dot-fire {
  1% {
    box-shadow: 9999px 22.5px 0 -5px #b9c0e9;
  }
  50% {
    box-shadow: 9999px -5.625px 0 2px #b9c0e9;
  }
  100% {
    box-shadow: 9999px -22.5px 0 -5px #b9c0e9;
  }
}
/**
 * ==============================================
 * Dot Spin
 * ==============================================
 */
.dot-spin {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: transparent;
  color: transparent;
  box-shadow: 0 -18px 0 0 #b9c0e9, 12.727926px -12.727926px 0 0 #b9c0e9, 18px 0 0 0 #b9c0e9, 12.727926px 12.727926px 0 0 rgba(185, 192, 233, 0), 0 18px 0 0 rgba(185, 192, 233, 0), -12.727926px 12.727926px 0 0 rgba(185, 192, 233, 0), -18px 0 0 0 rgba(185, 192, 233, 0), -12.727926px -12.727926px 0 0 rgba(185, 192, 233, 0);
  animation: dot-spin 1.5s infinite linear;
}

@keyframes dot-spin {
  0%, 100% {
    box-shadow: 0 -18px 0 0 #b9c0e9, 12.727926px -12.727926px 0 0 #b9c0e9, 18px 0 0 0 #b9c0e9, 12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), 0 18px 0 -5px rgba(185, 192, 233, 0), -12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), -18px 0 0 -5px rgba(185, 192, 233, 0), -12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0);
  }
  12.5% {
    box-shadow: 0 -18px 0 -5px rgba(185, 192, 233, 0), 12.727926px -12.727926px 0 0 #b9c0e9, 18px 0 0 0 #b9c0e9, 12.727926px 12.727926px 0 0 #b9c0e9, 0 18px 0 -5px rgba(185, 192, 233, 0), -12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), -18px 0 0 -5px rgba(185, 192, 233, 0), -12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0);
  }
  25% {
    box-shadow: 0 -18px 0 -5px rgba(185, 192, 233, 0), 12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0), 18px 0 0 0 #b9c0e9, 12.727926px 12.727926px 0 0 #b9c0e9, 0 18px 0 0 #b9c0e9, -12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), -18px 0 0 -5px rgba(185, 192, 233, 0), -12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0);
  }
  37.5% {
    box-shadow: 0 -18px 0 -5px rgba(185, 192, 233, 0), 12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0), 18px 0 0 -5px rgba(185, 192, 233, 0), 12.727926px 12.727926px 0 0 #b9c0e9, 0 18px 0 0 #b9c0e9, -12.727926px 12.727926px 0 0 #b9c0e9, -18px 0 0 -5px rgba(185, 192, 233, 0), -12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0);
  }
  50% {
    box-shadow: 0 -18px 0 -5px rgba(185, 192, 233, 0), 12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0), 18px 0 0 -5px rgba(185, 192, 233, 0), 12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), 0 18px 0 0 #b9c0e9, -12.727926px 12.727926px 0 0 #b9c0e9, -18px 0 0 0 #b9c0e9, -12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0);
  }
  62.5% {
    box-shadow: 0 -18px 0 -5px rgba(185, 192, 233, 0), 12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0), 18px 0 0 -5px rgba(185, 192, 233, 0), 12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), 0 18px 0 -5px rgba(185, 192, 233, 0), -12.727926px 12.727926px 0 0 #b9c0e9, -18px 0 0 0 #b9c0e9, -12.727926px -12.727926px 0 0 #b9c0e9;
  }
  75% {
    box-shadow: 0 -18px 0 0 #b9c0e9, 12.727926px -12.727926px 0 -5px rgba(185, 192, 233, 0), 18px 0 0 -5px rgba(185, 192, 233, 0), 12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), 0 18px 0 -5px rgba(185, 192, 233, 0), -12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), -18px 0 0 0 #b9c0e9, -12.727926px -12.727926px 0 0 #b9c0e9;
  }
  87.5% {
    box-shadow: 0 -18px 0 0 #b9c0e9, 12.727926px -12.727926px 0 0 #b9c0e9, 18px 0 0 -5px rgba(185, 192, 233, 0), 12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), 0 18px 0 -5px rgba(185, 192, 233, 0), -12.727926px 12.727926px 0 -5px rgba(185, 192, 233, 0), -18px 0 0 -5px rgba(185, 192, 233, 0), -12.727926px -12.727926px 0 0 #b9c0e9;
  }
}
/**
 * ==============================================
 * Dot Falling
 * ==============================================
 */
.dot-falling {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  box-shadow: 9999px 0 0 0 #b9c0e9;
  animation: dot-falling 1s infinite linear;
  animation-delay: 0.1s;
}
.dot-falling::before, .dot-falling::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-falling::before {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-falling-before 1s infinite linear;
  animation-delay: 0s;
}
.dot-falling::after {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-falling-after 1s infinite linear;
  animation-delay: 0.2s;
}

@keyframes dot-falling {
  0% {
    box-shadow: 9999px -15px 0 0 rgba(185, 192, 233, 0);
  }
  25%, 50%, 75% {
    box-shadow: 9999px 0 0 0 #b9c0e9;
  }
  100% {
    box-shadow: 9999px 15px 0 0 rgba(185, 192, 233, 0);
  }
}
@keyframes dot-falling-before {
  0% {
    box-shadow: 9984px -15px 0 0 rgba(185, 192, 233, 0);
  }
  25%, 50%, 75% {
    box-shadow: 9984px 0 0 0 #b9c0e9;
  }
  100% {
    box-shadow: 9984px 15px 0 0 rgba(185, 192, 233, 0);
  }
}
@keyframes dot-falling-after {
  0% {
    box-shadow: 10014px -15px 0 0 rgba(185, 192, 233, 0);
  }
  25%, 50%, 75% {
    box-shadow: 10014px 0 0 0 #b9c0e9;
  }
  100% {
    box-shadow: 10014px 15px 0 0 rgba(185, 192, 233, 0);
  }
}
/**
 * ==============================================
 * Dot Stretching
 * ==============================================
 */
.dot-stretching {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  transform: scale(1.25, 1.25);
  animation: dot-stretching 2s infinite ease-in;
}
.dot-stretching::before, .dot-stretching::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-stretching::before {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-stretching-before 2s infinite ease-in;
}
.dot-stretching::after {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #b9c0e9;
  color: #b9c0e9;
  animation: dot-stretching-after 2s infinite ease-in;
}

@keyframes dot-stretching {
  0% {
    transform: scale(1.25, 1.25);
  }
  50%, 60% {
    transform: scale(0.8, 0.8);
  }
  100% {
    transform: scale(1.25, 1.25);
  }
}
@keyframes dot-stretching-before {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%, 60% {
    transform: translate(-20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
@keyframes dot-stretching-after {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%, 60% {
    transform: translate(20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
/**
 * ==============================================
 * Experimental: Gooey Effect
 * Dot Gathering
 * ==============================================
 */
.dot-gathering {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: hsl(0, 100%, 0%);
  color: transparent;
  margin: -1px 0;
  filter: blur(2px);
}
.dot-gathering::before, .dot-gathering::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: -50px;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: hsl(0, 100%, 0%);
  color: transparent;
  opacity: 0;
  filter: blur(2px);
  animation: dot-gathering 2s infinite ease-in;
}
.dot-gathering::after {
  animation-delay: 0.5s;
}

@keyframes dot-gathering {
  0% {
    opacity: 0;
    transform: translateX(0);
  }
  35%, 60% {
    opacity: 1;
    transform: translateX(50px);
  }
  100% {
    opacity: 0;
    transform: translateX(100px);
  }
}
/**
 * ==============================================
 * Experimental: Gooey Effect
 * Dot Hourglass
 * ==============================================
 */
.dot-hourglass {
  position: relative;
  top: -15px;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: hsl(0, 100%, 0%);
  color: transparent;
  margin: -1px 0;
  filter: blur(2px);
  transform-origin: 5px 20px;
  animation: dot-hourglass 2.4s infinite ease-in-out;
  animation-delay: 0.6s;
}
.dot-hourglass::before, .dot-hourglass::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: hsl(0, 100%, 0%);
  color: transparent;
  filter: blur(2px);
}
.dot-hourglass::before {
  top: 30px;
}
.dot-hourglass::after {
  animation: dot-hourglass-after 2.4s infinite cubic-bezier(0.65, 0.05, 0.36, 1);
}

@keyframes dot-hourglass {
  0% {
    transform: rotateZ(0deg);
  }
  25% {
    transform: rotateZ(180deg);
  }
  50% {
    transform: rotateZ(180deg);
  }
  75% {
    transform: rotateZ(360deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
@keyframes dot-hourglass-after {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(30px);
  }
  50% {
    transform: translateY(30px);
  }
  75% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}
/**
 * ==============================================
 * Experimental: Gooey Effect
 * Dot Overtaking
 * ==============================================
 */
.dot-overtaking {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: transparent;
  color: hsl(0, 100%, 0%);
  margin: -1px 0;
  box-shadow: 0 -20px 0 0;
  filter: blur(2px);
  animation: dot-overtaking 2s infinite cubic-bezier(0.2, 0.6, 0.8, 0.2);
}
.dot-overtaking::before, .dot-overtaking::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: transparent;
  color: hsl(0, 100%, 0%);
  box-shadow: 0 -20px 0 0;
  filter: blur(2px);
}
.dot-overtaking::before {
  animation: dot-overtaking 2s infinite cubic-bezier(0.2, 0.6, 0.8, 0.2);
  animation-delay: 0.3s;
}
.dot-overtaking::after {
  animation: dot-overtaking 1.5s infinite cubic-bezier(0.2, 0.6, 0.8, 0.2);
  animation-delay: 0.6s;
}

@keyframes dot-overtaking {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
/**
 * ==============================================
 * Experimental: Gooey Effect
 * Dot Shuttle
 * ==============================================
 */
.dot-shuttle {
  position: relative;
  left: -15px;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: hsl(0, 100%, 0%);
  color: transparent;
  margin: -1px 0;
  filter: blur(2px);
}
.dot-shuttle::before, .dot-shuttle::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: hsl(0, 100%, 0%);
  color: transparent;
  filter: blur(2px);
}
.dot-shuttle::before {
  left: 15px;
  animation: dot-shuttle 2s infinite ease-out;
}
.dot-shuttle::after {
  left: 30px;
}

@keyframes dot-shuttle {
  0%, 50%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-45px);
  }
  75% {
    transform: translateX(45px);
  }
}
/**
 * ==============================================
 * Experimental: Emoji
 * Dot Bouncing
 * ==============================================
 */
.dot-bouncing {
  position: relative;
  height: 10px;
  font-size: 10px;
}
.dot-bouncing::before {
  content: "⚽🏀🏐";
  display: inline-block;
  position: relative;
  animation: dot-bouncing 1s infinite;
}

@keyframes dot-bouncing {
  0% {
    top: -20px;
    animation-timing-function: ease-in;
  }
  34% {
    transform: scale(1, 1);
  }
  35% {
    top: 20px;
    animation-timing-function: ease-out;
    transform: scale(1.5, 0.5);
  }
  45% {
    transform: scale(1, 1);
  }
  90% {
    top: -20px;
  }
  100% {
    top: -20px;
  }
}
/**
 * ==============================================
 * Experimental: Emoji
 * Dot Rolling
 * ==============================================
 */
.dot-rolling {
  position: relative;
  height: 10px;
  font-size: 10px;
}
.dot-rolling::before {
  content: "⚽";
  display: inline-block;
  position: relative;
  transform: translateX(-25px);
  animation: dot-rolling 3s infinite;
}

@keyframes dot-rolling {
  0% {
    content: "⚽";
    transform: translateX(-25px) rotateZ(0deg);
  }
  16.667% {
    content: "⚽";
    transform: translateX(25px) rotateZ(720deg);
  }
  33.333% {
    content: "⚽";
    transform: translateX(-25px) rotateZ(0deg);
  }
  34.333% {
    content: "🏀";
    transform: translateX(-25px) rotateZ(0deg);
  }
  50% {
    content: "🏀";
    transform: translateX(25px) rotateZ(720deg);
  }
  66.667% {
    content: "🏀";
    transform: translateX(-25px) rotateZ(0deg);
  }
  67.667% {
    content: "🏐";
    transform: translateX(-25px) rotateZ(0deg);
  }
  83.333% {
    content: "🏐";
    transform: translateX(25px) rotateZ(720deg);
  }
  100% {
    content: "🏐";
    transform: translateX(-25px) rotateZ(0deg);
  }
}
:host {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  flex-grow: 1;
  width: 100%;
  background: var(--ion-color-tertiary);
  overflow: auto;
  padding-top: var(--d-spacing-triple);
  display: flex;
  flex-direction: column;
}

.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
}

.message-bubble {
  margin: 0;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  padding-right: var(--d-spacing-double);
  padding-left: calc(var(--d-spacing-half) * 3);
}

.message {
  padding: 0 var(--d-spacing-double) var(--d-spacing-double) var(--d-spacing-double);
  display: flex;
  flex-direction: column;
}

.message.incoming {
  padding-right: calc(var(--d-spacing-double) * 2);
  justify-content: flex-start;
  align-items: flex-start;
}
.message.incoming .message-bubble {
  display: flex;
  flex-direction: row;
  border-radius: 1px var(--d-spacing-single) var(--d-spacing-single) var(--d-spacing-single);
  background: white;
}

.message.outgoing {
  padding-left: calc(var(--d-spacing-double) * 2);
  justify-content: flex-end;
  align-items: flex-end;
}
.message.outgoing .message-bubble {
  border-radius: var(--d-spacing-single) 1px var(--d-spacing-single) var(--d-spacing-single);
  background: rgba(var(--ion-color-primary-rgb), 0.8);
  padding-left: var(--d-spacing-double);
}

.buddy-icon {
  display: flex;
  width: 24px;
  height: 24px;
  margin-top: calc(var(--d-spacing-half) * 3);
  margin-right: calc(var(--d-spacing-half) * 3);
}

.feedback-icons {
  display: flex;
  justify-content: flex-end;
  margin-top: var(--d-spacing-single);
  margin-bottom: var(--d-spacing-half);
  transform: translateY(calc(-1 * var(--d-spacing-single)));
}
.feedback-icons ion-icon {
  height: 28px;
  width: 28px;
  margin-left: var(--d-spacing-single);
}

.question {
  padding: 0 var(--d-spacing-double) var(--d-spacing-double) calc(var(--d-spacing-double) * 2);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}

.question-bubble {
  margin: 0;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  padding: 0 var(--d-spacing-double);
  border-radius: var(--d-spacing-single) 1px var(--d-spacing-single) var(--d-spacing-single);
  background: rgba(var(--ion-color-primary-rgb), 0.05);
}

.question-area {
  flex-grow: 1;
  margin-top: calc(var(--d-spacing-double) * 6);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.dot-pulse {
  margin-left: calc(var(--d-spacing-double) * 2);
  margin-bottom: var(--d-spacing-double);
}

.container-selected {
  justify-content: flex-start;
  transition: justify-content 0.5s;
}

.question-area-selected {
  flex-grow: 0;
  justify-content: flex-start;
  transition: justify-content 0.5s;
}

.question-selected {
  order: -1;
}

.question-bubble-selected {
  transform: translateY(calc(-6 * var(--d-spacing-double)));
  transition: transform 0.5s;
}`, "",{"version":3,"sources":["webpack://./src/app/chatbot/buddy/buddy-messages/buddy-messages.component.scss","webpack://./node_modules/three-dots/scss/_dot-elastic.scss","webpack://./node_modules/three-dots/scss/_mixins.scss","webpack://./node_modules/three-dots/scss/_variables.scss","webpack://./node_modules/three-dots/scss/_dot-pulse.scss","webpack://./node_modules/three-dots/scss/_dot-flashing.scss","webpack://./node_modules/three-dots/scss/_dot-collision.scss","webpack://./node_modules/three-dots/scss/_dot-revolution.scss","webpack://./node_modules/three-dots/scss/_dot-carousel.scss","webpack://./node_modules/three-dots/scss/_dot-typing.scss","webpack://./node_modules/three-dots/scss/_dot-windmill.scss","webpack://./node_modules/three-dots/scss/_dot-bricks.scss","webpack://./node_modules/three-dots/scss/_dot-floating.scss","webpack://./node_modules/three-dots/scss/_dot-fire.scss","webpack://./node_modules/three-dots/scss/_dot-spin.scss","webpack://./node_modules/three-dots/scss/_dot-falling.scss","webpack://./node_modules/three-dots/scss/_dot-stretching.scss","webpack://./node_modules/three-dots/scss/_dot-gathering.scss","webpack://./node_modules/three-dots/scss/_dot-hourglass.scss","webpack://./node_modules/three-dots/scss/_dot-overtaking.scss","webpack://./node_modules/three-dots/scss/_dot-shuttle.scss","webpack://./node_modules/three-dots/scss/_dot-bouncing.scss","webpack://./node_modules/three-dots/scss/_dot-rolling.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;EAAA;AASA;EACE,kBAAA;ECGA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;ECad,yCAAA;ADAF;ACEE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;ADDJ;ACIE;EACE,WAAA;ECZF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EC4BZ,gDAAA;ADAJ;ACGE;EACE,UEpBU;EDAZ,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;ECoCZ,+CAAA;ADCJ;;ACGA;EACE;IACE,sBAAA;EDAF;ECGA;IACE,wBAAA;EDDF;ECIA;IACE,yBAAA;EDFF;ECKA;IACE,sBAAA;EDHF;ECMA;IACE,sBAAA;EDJF;AACF;ACOA;EACE;IACE,sBAAA;EDLF;ECQA;IACE,sBAAA;EDNF;ECSA;IACE,wBAAA;EDPF;ECUA;IACE,sBAAA;EDRF;ECWA;IACE,sBAAA;EDTF;AACF;ACYA;EACE;IACE,sBAAA;EDVF;ECaA;IACE,sBAAA;EDXF;ECcA;IACE,yBAAA;EDZF;ECeA;IACE,wBAAA;EDbF;ECgBA;IACE,sBAAA;EDdF;AACF;AI1FA;;;;EAAA;AAcA;EACE,kBAAA;EACA,aAPS;EFIT,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EImBd,2BAAA;EACA,yCAAA;EACA,sBAAA;AJqFF;AInFE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EFhBF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;AAqHhB;AIpFE;EACE,2BAAA;EACA,gDAAA;EACA,mBAAA;AJsFJ;AInFE;EACE,4BAAA;EACA,+CAAA;EACA,qBAAA;AJqFJ;;AIjFA;EACE;IACE,2BAAA;EJoFF;EIjFA;IACE,0BAAA;EJmFF;EIhFA;IAEE,2BAAA;EJiFF;AACF;AI9EA;EACE;IACE,2BAAA;EJgFF;EI7EA;IACE,0BAAA;EJ+EF;EI5EA;IAEE,2BAAA;EJ6EF;AACF;AI1EA;EACE;IACE,4BAAA;EJ4EF;EIzEA;IACE,2BAAA;EJ2EF;EIxEA;IAEE,4BAAA;EJyEF;AACF;AKlKA;;;;EAAA;AASA;EACE,kBAAA;EHGA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EKad,oDAAA;EACA,qBAAA;ALkKF;AKhKE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;ALiKJ;AK9JE;EACE,WAAA;EHbF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EK6BZ,6CAAA;EACA,mBAAA;ALkKJ;AK/JE;EACE,UFtBU;EDAZ,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EKsCZ,6CAAA;EACA,mBAAA;ALmKJ;;AK/JA;EACE;IACE,yBAAA;ELkKF;EK/JA;IAEE,0CAAA;ELgKF;AACF;AMpNA;;;;EAAA;AASA;EACE,kBAAA;EJGA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;AAgOhB;AMnNE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;ANoNJ;AMjNE;EACE,WAAA;EJVF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EM0BZ,mDAAA;ANqNJ;AMlNE;EACE,UH3BQ;EDSV,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EMkCZ,kDAAA;EACA,mBAAA;ANsNJ;;AMlNA;EACE;IAIE,wBAAA;ENkNF;EM/MA;IACE,4BAAA;ENiNF;AACF;AM9MA;EACE;IAIE,wBAAA;EN6MF;EM1MA;IACE,2BAAA;EN4MF;AACF;AO3QA;;;;EAAA;AASA;EACE,kBAAA;ELGA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;AAuRhB;AO1QE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;AP2QJ;AOxQE;EACE,OAAA;EACA,UAAA;ELVF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EO0BZ,0BAAA;EACA,8CAAA;AP4QJ;AOzQE;EACE,OAAA;EACA,UAAA;ELpBF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EOoCZ,0BAAA;EACA,4CAAA;AP6QJ;;AOzQA;EACE;IACE,6CAAA;EP4QF;EOzQA;IACE,+CAAA;EP2QF;AACF;AQ5TA;;;;EAAA;AAcA;EACE,kBAAA;EACA,aAPS;ENIT,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EQmBd,6EACE;EAGF,4CAAA;ARoTF;;AQjTA;EACE;IACE,qFACE;ERmTJ;EQ9SA;IACE,qFACE;ER+SJ;EQ1SA;IACE,qFACE;ER2SJ;AACF;ASxVA;;;;EAAA;AAcA;EACE,kBAAA;EACA,aAPS;EPIT,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;ESmBd,6EACE;EAGF,0CAAA;ATgVF;;AS7UA;EACE;IACE,6EACE;ET+UJ;ES1UA;IACE,iFACE;ET2UJ;EStUA;IACE,6EACE;ETuUJ;ESlUA;IACE,iFACE;ETmUJ;ES9TA;IACE,6EACE;ET+TJ;ES1TA;IACE,iFACE;ET2TJ;EStTA;IACE,6EACE;ETuTJ;AACF;AUhYA;;;;EAAA;AAaA;EACE,kBAAA;EACA,UAAA;ERFA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EUkBd,0BAAA;EACA,0CAAA;AV4XF;AU1XE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;AV2XJ;AUxXE;EACE,gBAAA;EACA,SAAA;ERlBF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;AA6ZhB;AU1XE;EACE,eAAA;EACA,SAAA;ERzBF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;AAsahB;;AU3XA;EACE;IACE,6CAAA;EV8XF;EU3XA;IACE,+CAAA;EV6XF;AACF;AWhbA;;;;EAAA;AAiBA;EACE,kBAAA;EACA,QATQ;EAUR,aATS;ETET,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EWuBd,iFACE;EAGF,sCAAA;AXqaF;;AWlaA;EACE;IACE,iFACE;EXoaJ;EW/ZA;IACE,kFACE;EXgaJ;EW3ZA;IACE,sFACE;EX4ZJ;EWvZA;IACE,qFACE;EXwZJ;EWnZA;IACE,iFACE;EXoZJ;EW/YA;IACE,kFACE;EXgZJ;EW3YA;IACE,sFACE;EX4YJ;EWvYA;IACE,qFACE;EXwYJ;EWnYA;IACE,iFACE;EXoYJ;EW/XA;IACE,kFACE;EXgYJ;EW3XA;IACE,sFACE;EX4XJ;EWvXA;IACE,qFACE;EXwXJ;EWnXA;IACE,iFACE;EXoXJ;AACF;AY3eA;;;;EAAA;AAYA;EACE,kBAAA;EVAA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EYgBd,qEAAA;AZweF;AYteE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;AZueJ;AYpeE;EACE,WAAA;EVfF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EY+BZ,sDAAA;AZweJ;AYreE;EACE,WAAA;EVvBF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EYuCZ,oEAAA;AZyeJ;;AYreA;EACE;IACE,sBAAA;EZweF;EYreA;IACE,uBAAA;EZueF;EYpeA;IACE,uBAAA;EZseF;AACF;AYneA;EACE;IACE,WAAA;EZqeF;EYleA;IACE,WAAA;EZoeF;EYjeA;IACE,WAAA;EZmeF;EYheA;IACE,WAAA;EZkeF;AACF;AY/dA;EACE;IACE,YAAA;EZieF;EY9dA;IACE,WAAA;EZgeF;EY7dA;IACE,YAAA;EZ+dF;EY5dA;IACE,YAAA;EZ8dF;AACF;AazjBA;;;;EAAA;AAeA;EACE,kBAAA;EACA,aARS;EXIT,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EaoBd,wCAAA;EACA,wCAAA;EACA,uBAAA;AbmjBF;AajjBE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EXjBF,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;AAolBhB;AaljBE;EACE,wCAAA;EACA,wCAAA;EACA,uBAAA;AbojBJ;AajjBE;EACE,wCAAA;EACA,wCAAA;EACA,uBAAA;AbmjBJ;;Aa/iBA;EACE;IACE,wCAAA;EbkjBF;Ea/iBA;IACE,yCAAA;EbijBF;Ea9iBA;IACE,yCAAA;EbgjBF;AACF;Ac3mBA;;;;EAAA;AAsBA;EACE,kBAAA;EZVA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,6BYS+B;EZR/B,kBYQoD;EAEpD,+TACE;EAQF,wCAAA;AdslBF;;AcnlBA;EACE;IAEE,8UACE;EdolBJ;Ec1kBA;IACE,8UACE;Ed2kBJ;EcjkBA;IACE,8UACE;EdkkBJ;EcxjBA;IACE,8UACE;EdyjBJ;Ec/iBA;IACE,8UACE;EdgjBJ;EctiBA;IACE,8UACE;EduiBJ;Ec7hBA;IACE,8UACE;Ed8hBJ;EcphBA;IACE,8UACE;EdqhBJ;AACF;AerpBA;;;;EAAA;AA2BA;EACE,kBAAA;EACA,aApBS;EbIT,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EegCd,gCAAA;EACA,yCAAA;EACA,qBAAA;AfmoBF;AejoBE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;AfkoBJ;Ae/nBE;EbhCA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;Ee+CZ,gDAAA;EACA,mBAAA;AfooBJ;AejoBE;EbvCA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EesDZ,+CAAA;EACA,qBAAA;AfsoBJ;;AeloBA;EACE;IACE,mDAAA;EfqoBF;EeloBA;IAGE,gCAAA;EfkoBF;Ee/nBA;IACE,kDAAA;EfioBF;AACF;Ae9nBA;EACE;IACE,mDAAA;EfgoBF;Ee7nBA;IAGE,gCAAA;Ef6nBF;Ee1nBA;IACE,kDAAA;Ef4nBF;AACF;AeznBA;EACE;IACE,oDAAA;Ef2nBF;EexnBA;IAGE,iCAAA;EfwnBF;EernBA;IACE,mDAAA;EfunBF;AACF;AgBhuBA;;;;EAAA;AAYA;EACE,kBAAA;EdAA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EgBgBd,4BAAA;EACA,6CAAA;AhB6tBF;AgB3tBE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;AhB4tBJ;AgBztBE;EdfA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EgB8BZ,oDAAA;AhB8tBJ;AgB3tBE;EdrBA,WCTU;EDUV,YCTW;EDUX,kBCTW;EDUX,yBFfc;EEgBd,cFhBc;EgBoCZ,mDAAA;AhBguBJ;;AgB5tBA;EACE;IACE,4BAAA;EhB+tBF;EgB5tBA;IAEE,0BAAA;EhB6tBF;EgB1tBA;IACE,4BAAA;EhB4tBF;AACF;AgBztBA;EACE;IACE,uCAAA;EhB2tBF;EgBxtBA;IAEE,uCAAA;EhBytBF;EgBttBA;IACE,uCAAA;EhBwtBF;AACF;AgBrtBA;EACE;IACE,uCAAA;EhButBF;EgBptBA;IAEE,sCAAA;EhBqtBF;EgBltBA;IACE,uCAAA;EhBotBF;AACF;AiBvyBA;;;;;EAAA;AAcA;EACE,kBAAA;EfFA,WeKU;EfJV,YeKW;EfJX,kBeKW;EfJX,kCeNc;EfOd,kBeKU;EAGV,cAAA;EACA,iBAAA;AjB6xBF;AiB3xBE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EfrBF,WewBY;EfvBZ,YewBa;EfvBb,kBewBa;EfvBb,kCeNc;EfOd,kBewBY;EAGV,UAAA;EACA,iBAAA;EACA,4CAAA;AjBwxBJ;AiBrxBE;EACE,qBAAA;AjBuxBJ;;AiBnxBA;EACE;IACE,UAAA;IACA,wBAAA;EjBsxBF;EiBnxBA;IAEE,UAAA;IACA,2BAAA;EjBoxBF;EiBjxBA;IACE,UAAA;IACA,4BAAA;EjBmxBF;AACF;AkBx1BA;;;;;EAAA;AAgBA;EACE,kBAAA;EACA,UAAA;EhBLA,WgBQU;EhBPV,YgBQW;EhBPX,kBgBQW;EhBPX,kCgBNc;EhBOd,kBgBQU;EAGV,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,kDAAA;EACA,qBAAA;AlB40BF;AkB10BE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EhB3BF,WgB8BY;EhB7BZ,YgB8Ba;EhB7Bb,kBgB8Ba;EhB7Bb,kCgBNc;EhBOd,kBgB8BY;EAGV,iBAAA;AlBu0BJ;AkBp0BE;EACE,SAAA;AlBs0BJ;AkBn0BE;EACE,8EAAA;AlBq0BJ;;AkBj0BA;EACE;IACE,wBAAA;ElBo0BF;EkBj0BA;IACE,0BAAA;ElBm0BF;EkBh0BA;IACE,0BAAA;ElBk0BF;EkB/zBA;IACE,0BAAA;ElBi0BF;EkB9zBA;IACE,0BAAA;ElBg0BF;AACF;AkB7zBA;EACE;IACE,wBAAA;ElB+zBF;EkB5zBA;IACE,2BAAA;ElB8zBF;EkB3zBA;IACE,2BAAA;ElB6zBF;EkB1zBA;IACE,wBAAA;ElB4zBF;EkBzzBA;IACE,wBAAA;ElB2zBF;AACF;AmBl6BA;;;;;EAAA;AAYA;EACE,kBAAA;EjBAA,WiBGU;EjBFV,YiBGW;EjBFX,kBiBGW;EjBFX,6BiBGa;EjBFb,uBiBPc;EAad,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,sEAAA;AnB05BF;AmBx5BE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EjBrBF,WiBwBY;EjBvBZ,YiBwBa;EjBvBb,kBiBwBa;EjBvBb,6BiBwBe;EjBvBf,uBiBPc;EAkCZ,uBAAA;EACA,iBAAA;AnBq5BJ;AmBl5BE;EACE,sEAAA;EACA,qBAAA;AnBo5BJ;AmBj5BE;EACE,wEAAA;EACA,qBAAA;AnBm5BJ;;AmB/4BA;EACE;IACE,wBAAA;EnBk5BF;EmB/4BA;IACE,0BAAA;EnBi5BF;AACF;AoBn9BA;;;;;EAAA;AAaA;EACE,kBAAA;EACA,WAAA;ElBFA,WkBKU;ElBJV,YkBKW;ElBJX,kBkBKW;ElBJX,kCkBLc;ElBMd,kBkBKU;EAGV,cAAA;EACA,iBAAA;ApB08BF;AoBx8BE;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;ElBpBF,WkBuBY;ElBtBZ,YkBuBa;ElBtBb,kBkBuBa;ElBtBb,kCkBLc;ElBMd,kBkBuBY;EAGV,iBAAA;ApBq8BJ;AoBl8BE;EACE,UjBlCU;EiBmCV,2CAAA;ApBo8BJ;AoBj8BE;EACE,UAAA;ApBm8BJ;;AoB/7BA;EACE;IAGE,wBAAA;EpBg8BF;EoB77BA;IACE,4BAAA;EpB+7BF;EoB57BA;IACE,2BAAA;EpB87BF;AACF;AqBngCA;;;;;EAAA;AAYA;EACE,kBAAA;EACA,YlBTW;EkBUX,eAAA;ArB+/BF;AqB7/BE;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mCAAA;ArB+/BJ;;AqB3/BA;EACE;IACE,UAAA;IACA,kCAAA;ErB8/BF;EqB3/BA;IACE,sBAAA;ErB6/BF;EqB1/BA;IACE,SA1BA;IA2BA,mCAAA;IACA,0BAAA;ErB4/BF;EqBz/BA;IACE,sBAAA;ErB2/BF;EqBx/BA;IACE,UAAA;ErB0/BF;EqBv/BA;IACE,UAAA;ErBy/BF;AACF;AsB5iCA;;;;;EAAA;AAYA;EACE,kBAAA;EACA,YnBTW;EmBUX,eAAA;AtBwiCF;AsBtiCE;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;AtBwiCJ;;AsBpiCA;EACE;IACE,YAAA;IACA,0CAAA;EtBuiCF;EsBpiCA;IACE,YAAA;IACA,2CAAA;EtBsiCF;EsBniCA;IACE,YAAA;IACA,0CAAA;EtBqiCF;EsBliCA;IACE,aAAA;IACA,0CAAA;EtBoiCF;EsBjiCA;IACE,aAAA;IACA,2CAAA;EtBmiCF;EsBhiCA;IACE,aAAA;IACA,0CAAA;EtBkiCF;EsB/hCA;IACE,aAAA;IACA,0CAAA;EtBiiCF;EsB9hCA;IACE,aAAA;IACA,2CAAA;EtBgiCF;EsB7hCA;IACE,aAAA;IACA,0CAAA;EtB+hCF;AACF;AAhmCA;EuBGI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EvBJA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AAqmCJ;;AAlmCA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AAqmCJ;;AAlmCA;EACI,SAAA;EACA,0CAAA;EACA,sCAAA;EACA,6CAAA;AAqmCJ;;AAlmCA;EACI,kFAAA;EACA,aAAA;EACA,sBAAA;AAqmCJ;;AAlmCA;EACI,gDAAA;EACA,2BAAA;EACA,uBAAA;AAqmCJ;AAnmCI;EACI,aAAA;EACA,mBAAA;EACA,0FAAA;EACA,iBAAA;AAqmCR;;AAjmCA;EACI,+CAAA;EACA,yBAAA;EACA,qBAAA;AAomCJ;AAlmCI;EACI,0FAAA;EACA,mDAAA;EACA,qCAAA;AAomCR;;AAhmCA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,6CAAA;AAmmCJ;;AAhmCA;EACI,aAAA;EACA,yBAAA;EACA,mCAAA;EACA,oCAAA;EACA,yDAAA;AAmmCJ;AAjmCI;EACI,YAAA;EACA,WAAA;EACA,oCAAA;AAmmCR;;AA/lCA;EACI,4FAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAkmCJ;;AA/lCA;EACI,SAAA;EACA,0CAAA;EACA,kCAAA;EACA,0FAAA;EACA,oDAAA;AAkmCJ;;AA/lCA;EACI,YAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAkmCJ;;AA/lCA;EACI,8CAAA;EACA,sCAAA;AAkmCJ;;AA/lCA;EACI,2BAAA;EACA,gCAAA;AAkmCJ;;AA/lCA;EACI,YAAA;EACA,2BAAA;EACA,gCAAA;AAkmCJ;;AA/lCA;EACI,SAAA;AAkmCJ;;AA/lCA;EACI,yDAAA;EACA,0BAAA;AAkmCJ","sourcesContent":["@use 'node_modules/three-dots/index' with (\n    $dot-color: #b9c0e9\n);\n@import '../../../../mixins';\n\n:host {\n    @include p1-style;\n    flex-grow: 1;\n    width: 100%;\n    background: var(--ion-color-tertiary);\n    overflow: auto;\n    padding-top: var(--d-spacing-triple);\n    display: flex;\n    flex-direction: column;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: space-between;\n}\n\n.message-bubble {\n    margin: 0;\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n    padding-right: var(--d-spacing-double);\n    padding-left: calc(var(--d-spacing-half) * 3);\n}\n\n.message {\n    padding: 0 var(--d-spacing-double) var(--d-spacing-double) var(--d-spacing-double);\n    display: flex;\n    flex-direction: column;\n}\n\n.message.incoming {\n    padding-right: calc(var(--d-spacing-double) * 2);\n    justify-content: flex-start;\n    align-items: flex-start;\n\n    .message-bubble {\n        display: flex;\n        flex-direction: row;\n        border-radius: 1px var(--d-spacing-single) var(--d-spacing-single) var(--d-spacing-single);\n        background: white;\n    }\n}\n\n.message.outgoing {\n    padding-left: calc(var(--d-spacing-double) * 2);\n    justify-content: flex-end;\n    align-items: flex-end;\n\n    .message-bubble {\n        border-radius: var(--d-spacing-single) 1px var(--d-spacing-single) var(--d-spacing-single);\n        background: rgba(var(--ion-color-primary-rgb), 0.8);\n        padding-left: var(--d-spacing-double);\n    }\n}\n\n.buddy-icon {\n    display: flex;\n    width: 24px;\n    height: 24px;\n    margin-top: calc(var(--d-spacing-half) * 3);\n    margin-right: calc(var(--d-spacing-half) * 3);\n}\n\n.feedback-icons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: var(--d-spacing-single);\n    margin-bottom: var(--d-spacing-half);\n    transform: translateY(calc(-1 * var(--d-spacing-single)));\n\n    ion-icon {\n        height: 28px;\n        width: 28px;\n        margin-left: var(--d-spacing-single);\n    }\n}\n\n.question {\n    padding: 0 var(--d-spacing-double) var(--d-spacing-double) calc(var(--d-spacing-double) * 2);\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-end;\n}\n\n.question-bubble {\n    margin: 0;\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n    padding: 0 var(--d-spacing-double);\n    border-radius: var(--d-spacing-single) 1px var(--d-spacing-single) var(--d-spacing-single);\n    background: rgba(var(--ion-color-primary-rgb), 0.05);\n}\n\n.question-area {\n    flex-grow: 1;\n    margin-top: calc(var(--d-spacing-double) * 6);\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n}\n\n.dot-pulse {\n    margin-left: calc(var(--d-spacing-double) * 2);\n    margin-bottom: var(--d-spacing-double);\n}\n\n.container-selected {\n    justify-content: flex-start;\n    transition: justify-content 0.5s;\n}\n\n.question-area-selected {\n    flex-grow: 0;\n    justify-content: flex-start;\n    transition: justify-content 0.5s;\n}\n\n.question-selected {\n    order: -1;\n}\n\n.question-bubble-selected {\n    transform: translateY(calc(-1 * 6 * var(--d-spacing-double)));\n    transition: transform 0.5s;\n}\n","/**\n * ==============================================\n * Dot Elastic\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n.dot-elastic {\n  position: relative;\n\n  @include mixins.dot;\n\n  animation: dot-elastic 1s infinite linear;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n  }\n\n  &::before {\n    left: - variables.$dot-spacing;\n\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    animation: dot-elastic-before 1s infinite linear;\n  }\n\n  &::after {\n    left: variables.$dot-spacing;\n\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    animation: dot-elastic-after 1s infinite linear;\n  }\n}\n\n@keyframes dot-elastic-before {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  25% {\n    transform: scale(1, 1.5);\n  }\n\n  50% {\n    transform: scale(1, .67);\n  }\n\n  75% {\n    transform: scale(1, 1);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes dot-elastic {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  25% {\n    transform: scale(1, 1);\n  }\n\n  50% {\n    transform: scale(1, 1.5);\n  }\n\n  75% {\n    transform: scale(1, 1);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes dot-elastic-after {\n  0% {\n    transform: scale(1, 1);\n  }\n\n  25% {\n    transform: scale(1, 1);\n  }\n\n  50% {\n    transform: scale(1, .67);\n  }\n\n  75% {\n    transform: scale(1, 1.5);\n  }\n\n  100% {\n    transform: scale(1, 1);\n  }\n}\n","// ==============================================\n// Mixins\n// ==============================================\n\n@use './variables';\n\n@mixin dot(\n  $width: variables.$dot-width,\n  $height: variables.$dot-height,\n  $radius: variables.$dot-radius,\n  $bg-color: variables.$dot-bg-color,\n  $color: variables.$dot-color\n) {\n  width: $width;\n  height: $height;\n  border-radius: $radius;\n  background-color: $bg-color;\n  color: $color;\n}\n","// ==============================================\n// Variables\n// ==============================================\n\n$dot-width: 10px !default;\n$dot-height: 10px !default;\n$dot-radius: $dot-width * .5 !default;\n\n$dot-color: #9880ff !default;\n$dot-bg-color: $dot-color !default;\n$dot-before-color: $dot-color !default;\n$dot-after-color: $dot-color !default;\n\n$dot-spacing: $dot-width + $dot-width * .5 !default;\n","/**\n * ==============================================\n * Dot Pulse\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$left-pos: -9999px;\n$x1: - $left-pos - variables.$dot-spacing;\n$x2: - $left-pos;\n$x3: - $left-pos + variables.$dot-spacing;\n\n.dot-pulse {\n  position: relative;\n  left: $left-pos;\n\n  @include mixins.dot;\n\n  box-shadow: $x2 0 0 -5px;\n  animation: dot-pulse 1.5s infinite linear;\n  animation-delay: .25s;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n\n    @include mixins.dot;\n  }\n\n  &::before {\n    box-shadow: $x1 0 0 -5px;\n    animation: dot-pulse-before 1.5s infinite linear;\n    animation-delay: 0s;\n  }\n\n  &::after {\n    box-shadow: $x3 0 0 -5px;\n    animation: dot-pulse-after 1.5s infinite linear;\n    animation-delay: .5s;\n  }\n}\n\n@keyframes dot-pulse-before {\n  0% {\n    box-shadow: $x1 0 0 -5px;\n  }\n\n  30% {\n    box-shadow: $x1 0 0 2px;\n  }\n\n  60%,\n  100% {\n    box-shadow: $x1 0 0 -5px;\n  }\n}\n\n@keyframes dot-pulse {\n  0% {\n    box-shadow: $x2 0 0 -5px;\n  }\n\n  30% {\n    box-shadow: $x2 0 0 2px;\n  }\n\n  60%,\n  100% {\n    box-shadow: $x2 0 0 -5px;\n  }\n}\n\n@keyframes dot-pulse-after {\n  0% {\n    box-shadow: $x3 0 0 -5px;\n  }\n\n  30% {\n    box-shadow: $x3 0 0 2px;\n  }\n\n  60%,\n  100% {\n    box-shadow: $x3 0 0 -5px;\n  }\n}\n","/**\n * ==============================================\n * Dot Flashing\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n.dot-flashing {\n  position: relative;\n\n  @include mixins.dot;\n\n  animation: dot-flashing 1s infinite linear alternate;\n  animation-delay: .5s;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n  }\n\n  &::before {\n    left: - variables.$dot-spacing;\n\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    animation: dot-flashing 1s infinite alternate;\n    animation-delay: 0s;\n  }\n\n  &::after {\n    left: variables.$dot-spacing;\n\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    animation: dot-flashing 1s infinite alternate;\n    animation-delay: 1s;\n  }\n}\n\n@keyframes dot-flashing {\n  0% {\n    background-color: rgba(variables.$dot-color, 1);\n  }\n\n  50%,\n  100% {\n    background-color: rgba(variables.$dot-color, .2);\n  }\n}\n","/**\n * ==============================================\n * Dot Collision\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n.dot-collision {\n  position: relative;\n\n  @include mixins.dot;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n  }\n\n  &::before {\n    left: - variables.$dot-width;\n\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    animation: dot-collision-before 2s infinite ease-in;\n  }\n\n  &::after {\n    left: variables.$dot-width;\n\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    animation: dot-collision-after 2s infinite ease-in;\n    animation-delay: 1s;\n  }\n}\n\n@keyframes dot-collision-before {\n  0%,\n  50%,\n  75%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25% {\n    transform: translateX(- variables.$dot-spacing);\n  }\n}\n\n@keyframes dot-collision-after {\n  0%,\n  50%,\n  75%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25% {\n    transform: translateX(variables.$dot-spacing);\n  }\n}\n","/**\n * ==============================================\n * Dot Revolution\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n.dot-revolution {\n  position: relative;\n\n  @include mixins.dot;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n  }\n\n  &::before {\n    left: 0;\n    top: - variables.$dot-spacing;\n\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    transform-origin: (variables.$dot-width * .5) (variables.$dot-spacing + variables.$dot-width * .5);\n    animation: dot-revolution 1.4s linear infinite;\n  }\n\n  &::after {\n    left: 0;\n    top: - variables.$dot-spacing * 2;\n\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    transform-origin: (variables.$dot-width * .5) (variables.$dot-spacing * 2 + variables.$dot-width * .5);\n    animation: dot-revolution 1s linear infinite;\n  }\n}\n\n@keyframes dot-revolution {\n  0% {\n    transform: rotateZ(0deg) translate3d(0, 0, 0);\n  }\n\n  100% {\n    transform: rotateZ(360deg) translate3d(0, 0, 0);\n  }\n}\n","/**\n * ==============================================\n * Dot Carousel\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$left-pos: -9999px;\n$x1: - $left-pos - variables.$dot-spacing;\n$x2: - $left-pos;\n$x3: - $left-pos + variables.$dot-spacing;\n\n.dot-carousel {\n  position: relative;\n  left: $left-pos;\n\n  @include mixins.dot;\n\n  box-shadow:\n    $x1 0 0 0 variables.$dot-before-color,\n    $x2 0 0 0 variables.$dot-color,\n    $x3 0 0 0 variables.$dot-after-color;\n  animation: dot-carousel 1.5s infinite linear;\n}\n\n@keyframes dot-carousel {\n  0% {\n    box-shadow:\n      $x1 0 0 -1px variables.$dot-before-color,\n      $x2 0 0 1px variables.$dot-color,\n      $x3 0 0 -1px variables.$dot-after-color;\n  }\n\n  50% {\n    box-shadow:\n      $x3 0 0 -1px variables.$dot-before-color,\n      $x1 0 0 -1px variables.$dot-color,\n      $x2 0 0 1px variables.$dot-after-color;\n  }\n\n  100% {\n    box-shadow:\n      $x2 0 0 1px variables.$dot-before-color,\n      $x3 0 0 -1px variables.$dot-color,\n      $x1 0 0 -1px variables.$dot-after-color;\n  }\n}\n","/**\n * ==============================================\n * Dot Typing\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$left-pos: -9999px;\n$x1: - $left-pos - variables.$dot-spacing;\n$x2: - $left-pos;\n$x3: - $left-pos + variables.$dot-spacing;\n\n.dot-typing {\n  position: relative;\n  left: $left-pos;\n\n  @include mixins.dot;\n\n  box-shadow:\n    $x1 0 0 0 variables.$dot-before-color,\n    $x2 0 0 0 variables.$dot-color,\n    $x3 0 0 0 variables.$dot-after-color;\n  animation: dot-typing 1.5s infinite linear;\n}\n\n@keyframes dot-typing {\n  0% {\n    box-shadow:\n      $x1 0 0 0 variables.$dot-before-color,\n      $x2 0 0 0 variables.$dot-color,\n      $x3 0 0 0 variables.$dot-after-color;\n  }\n\n  16.667% {\n    box-shadow:\n      $x1 -10px 0 0 variables.$dot-before-color,\n      $x2 0 0 0 variables.$dot-color,\n      $x3 0 0 0 variables.$dot-after-color;\n  }\n\n  33.333% {\n    box-shadow:\n      $x1 0 0 0 variables.$dot-before-color,\n      $x2 0 0 0 variables.$dot-color,\n      $x3 0 0 0 variables.$dot-after-color;\n  }\n\n  50% {\n    box-shadow:\n      $x1 0 0 0 variables.$dot-before-color,\n      $x2 -10px 0 0 variables.$dot-color,\n      $x3 0 0 0 variables.$dot-after-color;\n  }\n\n  66.667% {\n    box-shadow:\n      $x1 0 0 0 variables.$dot-before-color,\n      $x2 0 0 0 variables.$dot-color,\n      $x3 0 0 0 variables.$dot-after-color;\n  }\n\n  83.333% {\n    box-shadow:\n      $x1 0 0 0 variables.$dot-before-color,\n      $x2 0 0 0 variables.$dot-color,\n      $x3 -10px 0 0 variables.$dot-after-color;\n  }\n\n  100% {\n    box-shadow:\n      $x1 0 0 0 variables.$dot-before-color,\n      $x2 0 0 0 variables.$dot-color,\n      $x3 0 0 0 variables.$dot-after-color;\n  }\n}\n","/**\n * ==============================================\n * Dot Windmill\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$r: 10px;\n$origin-x: 5px;\n$origin-y: 5px + $r;\n\n.dot-windmill {\n  position: relative;\n  top: - $r;\n\n  @include mixins.dot;\n\n  transform-origin: $origin-x $origin-y;\n  animation: dot-windmill 2s infinite linear;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n  }\n\n  &::before {\n    left: -($r * .5 * 1.732508); // √3\n    top: $r + $r * .5;\n\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n  }\n\n  &::after {\n    left: $r * .5 * 1.732508; // √3\n    top: $r + $r * .5;\n\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n  }\n}\n\n@keyframes dot-windmill {\n  0% {\n    transform: rotateZ(0deg) translate3d(0, 0, 0);\n  }\n\n  100% {\n    transform: rotateZ(720deg) translate3d(0, 0, 0);\n  }\n}\n","/**\n * ==============================================\n * Dot Bricks\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$spacing: variables.$dot-width + 6px;\n$top-pos: $spacing * .5;\n$left-pos: -9999px;\n$x1: - $left-pos - $top-pos;\n$x2: - $left-pos - $top-pos + $spacing;\n$y1: 0;\n$y2: - $spacing;\n\n.dot-bricks {\n  position: relative;\n  top: $top-pos;\n  left: $left-pos;\n\n  @include mixins.dot;\n\n  box-shadow:\n    $x1 $y2 0 0 variables.$dot-before-color,\n    $x1 $y1 0 0 variables.$dot-color,\n    $x2 $y1 0 0 variables.$dot-after-color;\n  animation: dot-bricks 2s infinite ease;\n}\n\n@keyframes dot-bricks {\n  0% {\n    box-shadow:\n      $x1 $y2 0 0 variables.$dot-before-color,\n      $x1 $y1 0 0 variables.$dot-color,\n      $x2 $y1 0 0 variables.$dot-after-color;\n  }\n\n  8.333% {\n    box-shadow:\n      $x2 $y2 0 0 variables.$dot-before-color,\n      $x1 $y1 0 0 variables.$dot-color,\n      $x2 $y1 0 0 variables.$dot-after-color;\n  }\n\n  16.667% {\n    box-shadow:\n      $x2 $y2 0 0 variables.$dot-before-color,\n      $x1 $y2 0 0 variables.$dot-color,\n      $x2 $y1 0 0 variables.$dot-after-color;\n  }\n\n  25% {\n    box-shadow:\n      $x2 $y2 0 0 variables.$dot-before-color,\n      $x1 $y2 0 0 variables.$dot-color,\n      $x1 $y1 0 0 variables.$dot-after-color;\n  }\n\n  33.333% {\n    box-shadow:\n      $x2 $y1 0 0 variables.$dot-before-color,\n      $x1 $y2 0 0 variables.$dot-color,\n      $x1 $y1 0 0 variables.$dot-after-color;\n  }\n\n  41.667% {\n    box-shadow:\n      $x2 $y1 0 0 variables.$dot-before-color,\n      $x2 $y2 0 0 variables.$dot-color,\n      $x1 $y1 0 0 variables.$dot-after-color;\n  }\n\n  50% {\n    box-shadow:\n      $x2 $y1 0 0 variables.$dot-before-color,\n      $x2 $y2 0 0 variables.$dot-color,\n      $x1 $y2 0 0 variables.$dot-after-color;\n  }\n\n  58.333% {\n    box-shadow:\n      $x1 $y1 0 0 variables.$dot-before-color,\n      $x2 $y2 0 0 variables.$dot-color,\n      $x1 $y2 0 0 variables.$dot-after-color;\n  }\n\n  66.666% {\n    box-shadow:\n      $x1 $y1 0 0 variables.$dot-before-color,\n      $x2 $y1 0 0 variables.$dot-color,\n      $x1 $y2 0 0 variables.$dot-after-color;\n  }\n\n  75% {\n    box-shadow:\n      $x1 $y1 0 0 variables.$dot-before-color,\n      $x2 $y1 0 0 variables.$dot-color,\n      $x2 $y2 0 0 variables.$dot-after-color;\n  }\n\n  83.333% {\n    box-shadow:\n      $x1 $y2 0 0 variables.$dot-before-color,\n      $x2 $y1 0 0 variables.$dot-color,\n      $x2 $y2 0 0 variables.$dot-after-color;\n  }\n\n  91.667% {\n    box-shadow:\n      $x1 $y2 0 0 variables.$dot-before-color,\n      $x1 $y1 0 0 variables.$dot-color,\n      $x2 $y2 0 0 variables.$dot-after-color;\n  }\n\n  100% {\n    box-shadow:\n      $x1 $y2 0 0 variables.$dot-before-color,\n      $x1 $y1 0 0 variables.$dot-color,\n      $x2 $y1 0 0 variables.$dot-after-color;\n  }\n}\n","/**\n * ==============================================\n * Dot Floating\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$d-max: 50px;\n$d-min: 12px;\n\n.dot-floating {\n  position: relative;\n\n  @include mixins.dot;\n\n  animation: dot-floating 3s infinite cubic-bezier(.15, .6, .9, .1);\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n  }\n\n  &::before {\n    left: - $d-min;\n\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    animation: dot-floating-before 3s infinite ease-in-out;\n  }\n\n  &::after {\n    left: - $d-min * 2;\n\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    animation: dot-floating-after 3s infinite cubic-bezier(.4, 0, 1, 1);\n  }\n}\n\n@keyframes dot-floating {\n  0% {\n    left: calc(-50% - #{variables.$dot-width * .5});\n  }\n\n  75% {\n    left: calc(50% + #{$d-max * 2 + variables.$dot-width * .5});\n  }\n\n  100% {\n    left: calc(50% + #{$d-max * 2 + variables.$dot-width * .5});\n  }\n}\n\n@keyframes dot-floating-before {\n  0% {\n    left: - $d-max;\n  }\n\n  50% {\n    left: - $d-min;\n  }\n\n  75% {\n    left: - $d-max;\n  }\n\n  100% {\n    left: - $d-max;\n  }\n}\n\n@keyframes dot-floating-after {\n  0% {\n    left: - $d-max * 2;\n  }\n\n  50% {\n    left: - $d-min * 2;\n  }\n\n  75% {\n    left: - $d-max * 2;\n  }\n\n  100% {\n    left: - $d-max * 2;\n  }\n}\n","/**\n * ==============================================\n * Dot Fire\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$left-pos: -9999px;\n$x1: - $left-pos;\n$y1: -1.5 * variables.$dot-spacing;\n$y2: -1.5 * variables.$dot-spacing * .25;\n$y3: 1.5 * variables.$dot-spacing;\n\n.dot-fire {\n  position: relative;\n  left: $left-pos;\n\n  @include mixins.dot;\n\n  box-shadow: $x1 $y3 0 -5px variables.$dot-color;\n  animation: dot-fire 1.5s infinite linear;\n  animation-delay: -.85s;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n\n    @include mixins.dot;\n  }\n\n  &::before {\n    box-shadow: $x1 $y3 0 -5px variables.$dot-before-color;\n    animation: dot-fire 1.5s infinite linear;\n    animation-delay: -1.85s;\n  }\n\n  &::after {\n    box-shadow: $x1 $y3 0 -5px variables.$dot-after-color;\n    animation: dot-fire 1.5s infinite linear;\n    animation-delay: -2.85s;\n  }\n}\n\n@keyframes dot-fire {\n  1% {\n    box-shadow: $x1 $y3 0 -5px variables.$dot-after-color;\n  }\n\n  50% {\n    box-shadow: $x1 $y2 0 2px variables.$dot-after-color;\n  }\n\n  100% {\n    box-shadow: $x1 $y1 0 -5px variables.$dot-after-color;\n  }\n}\n","/**\n * ==============================================\n * Dot Spin\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$x1: variables.$dot-spacing * 1.2;\n$y1: variables.$dot-spacing * 1.2;\n$-x1: - $x1;\n$-y1: - $y1;\n\n$x2: $x1 * .707107; // 1/√2\n$y2: $y1 * .707107; // 1/√2\n$-x2: - $x2;\n$-y2: - $y2;\n\n$color-0: rgba(variables.$dot-color, 0);\n$color-1: rgba(variables.$dot-color, 1);\n\n.dot-spin {\n  position: relative;\n\n  @include mixins.dot($bg-color: transparent, $color: transparent);\n\n  box-shadow:\n    0 $-y1 0 0 $color-1,\n    $x2 $-y2 0 0 $color-1,\n    $x1 0 0 0 $color-1,\n    $x2 $y2 0 0 $color-0,\n    0 $y1 0 0 $color-0,\n    $-x2 $y2 0 0 $color-0,\n    $-x1 0 0 0 $color-0,\n    $-x2 $-y2 0 0 $color-0;\n  animation: dot-spin 1.5s infinite linear;\n}\n\n@keyframes dot-spin {\n  0%,\n  100% {\n    box-shadow:\n      0 $-y1 0 0 $color-1,\n      $x2 $-y2 0 0 $color-1,\n      $x1 0 0 0 $color-1,\n      $x2 $y2 0 -5px $color-0,\n      0 $y1 0 -5px $color-0,\n      $-x2 $y2 0 -5px $color-0,\n      $-x1 0 0 -5px $color-0,\n      $-x2 $-y2 0 -5px $color-0;\n  }\n\n  12.5% {\n    box-shadow:\n      0 $-y1 0 -5px $color-0,\n      $x2 $-y2 0 0 $color-1,\n      $x1 0 0 0 $color-1,\n      $x2 $y2 0 0 $color-1,\n      0 $y1 0 -5px $color-0,\n      $-x2 $y2 0 -5px $color-0,\n      $-x1 0 0 -5px $color-0,\n      $-x2 $-y2 0 -5px $color-0;\n  }\n\n  25% {\n    box-shadow:\n      0 $-y1 0 -5px $color-0,\n      $x2 $-y2 0 -5px $color-0,\n      $x1 0 0 0 $color-1,\n      $x2 $y2 0 0 $color-1,\n      0 $y1 0 0 $color-1,\n      $-x2 $y2 0 -5px $color-0,\n      $-x1 0 0 -5px $color-0,\n      $-x2 $-y2 0 -5px $color-0;\n  }\n\n  37.5% {\n    box-shadow:\n      0 $-y1 0 -5px $color-0,\n      $x2 $-y2 0 -5px $color-0,\n      $x1 0 0 -5px $color-0,\n      $x2 $y2 0 0 $color-1,\n      0 $y1 0 0 $color-1,\n      $-x2 $y2 0 0 $color-1,\n      $-x1 0 0 -5px $color-0,\n      $-x2 $-y2 0 -5px $color-0;\n  }\n\n  50% {\n    box-shadow:\n      0 $-y1 0 -5px $color-0,\n      $x2 $-y2 0 -5px $color-0,\n      $x1 0 0 -5px $color-0,\n      $x2 $y2 0 -5px $color-0,\n      0 $y1 0 0 $color-1,\n      $-x2 $y2 0 0 $color-1,\n      $-x1 0 0 0 $color-1,\n      $-x2 $-y2 0 -5px $color-0;\n  }\n\n  62.5% {\n    box-shadow:\n      0 $-y1 0 -5px $color-0,\n      $x2 $-y2 0 -5px $color-0,\n      $x1 0 0 -5px $color-0,\n      $x2 $y2 0 -5px $color-0,\n      0 $y1 0 -5px $color-0,\n      $-x2 $y2 0 0 $color-1,\n      $-x1 0 0 0 $color-1,\n      $-x2 $-y2 0 0 $color-1;\n  }\n\n  75% {\n    box-shadow:\n      0 $-y1 0 0 $color-1,\n      $x2 $-y2 0 -5px $color-0,\n      $x1 0 0 -5px $color-0,\n      $x2 $y2 0 -5px $color-0,\n      0 $y1 0 -5px $color-0,\n      $-x2 $y2 0 -5px $color-0,\n      $-x1 0 0 0 $color-1,\n      $-x2 $-y2 0 0 $color-1;\n  }\n\n  87.5% {\n    box-shadow:\n      0 $-y1 0 0 $color-1,\n      $x2 $-y2 0 0 $color-1,\n      $x1 0 0 -5px $color-0,\n      $x2 $y2 0 -5px $color-0,\n      0 $y1 0 -5px $color-0,\n      $-x2 $y2 0 -5px $color-0,\n      $-x1 0 0 -5px $color-0,\n      $-x2 $-y2 0 0 $color-1;\n  }\n}\n","/**\n * ==============================================\n * Dot Falling\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$left-pos: -9999px;\n$x1: - $left-pos - variables.$dot-spacing;\n$x2: - $left-pos;\n$x3: - $left-pos + variables.$dot-spacing;\n\n$y1: - variables.$dot-spacing;\n$y2: 0;\n$y3: variables.$dot-spacing;\n\n$color-0: rgba(variables.$dot-color, 0);\n$color-1: rgba(variables.$dot-color, 1);\n\n$color-before-0: rgba(variables.$dot-before-color, 0);\n$color-before-1: rgba(variables.$dot-before-color, 1);\n\n$color-after-0: rgba(variables.$dot-after-color, 0);\n$color-after-1: rgba(variables.$dot-after-color, 1);\n\n.dot-falling {\n  position: relative;\n  left: $left-pos;\n\n  @include mixins.dot;\n\n  box-shadow: $x2 0 0 0 variables.$dot-color;\n  animation: dot-falling 1s infinite linear;\n  animation-delay: .1s;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n  }\n\n  &::before {\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    animation: dot-falling-before 1s infinite linear;\n    animation-delay: 0s;\n  }\n\n  &::after {\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    animation: dot-falling-after 1s infinite linear;\n    animation-delay: .2s;\n  }\n}\n\n@keyframes dot-falling {\n  0% {\n    box-shadow: $x2 $y1 0 0 $color-0;\n  }\n\n  25%,\n  50%,\n  75% {\n    box-shadow: $x2 $y2 0 0 $color-1;\n  }\n\n  100% {\n    box-shadow: $x2 $y3 0 0 $color-0;\n  }\n}\n\n@keyframes dot-falling-before {\n  0% {\n    box-shadow: $x1 $y1 0 0 $color-before-0;\n  }\n\n  25%,\n  50%,\n  75% {\n    box-shadow: $x1 $y2 0 0 $color-before-1;\n  }\n\n  100% {\n    box-shadow: $x1 $y3 0 0 $color-before-0;\n  }\n}\n\n@keyframes dot-falling-after {\n  0% {\n    box-shadow: $x3 $y1 0 0 $color-after-0;\n  }\n\n  25%,\n  50%,\n  75% {\n    box-shadow: $x3 $y2 0 0 $color-after-1;\n  }\n\n  100% {\n    box-shadow: $x3 $y3 0 0 $color-after-0;\n  }\n}\n","/**\n * ==============================================\n * Dot Stretching\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$ratio1: .8;\n$ratio2: .7;\n\n.dot-stretching {\n  position: relative;\n\n  @include mixins.dot;\n\n  transform: scale(1.25, 1.25);\n  animation: dot-stretching 2s infinite ease-in;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n  }\n\n  &::before {\n    @include mixins.dot($bg-color: variables.$dot-before-color);\n\n    animation: dot-stretching-before 2s infinite ease-in;\n  }\n\n  &::after {\n    @include mixins.dot($bg-color: variables.$dot-after-color);\n\n    animation: dot-stretching-after 2s infinite ease-in;\n  }\n}\n\n@keyframes dot-stretching {\n  0% {\n    transform: scale(1.25, 1.25);\n  }\n\n  50%,\n  60% {\n    transform: scale($ratio1, $ratio1);\n  }\n\n  100% {\n    transform: scale(1.25, 1.25);\n  }\n}\n\n@keyframes dot-stretching-before {\n  0% {\n    transform: translate(0) scale($ratio2, $ratio2);\n  }\n\n  50%,\n  60% {\n    transform: translate(-20px) scale(1, 1);\n  }\n\n  100% {\n    transform: translate(0) scale($ratio2, $ratio2);\n  }\n}\n\n@keyframes dot-stretching-after {\n  0% {\n    transform: translate(0) scale($ratio2, $ratio2);\n  }\n\n  50%,\n  60% {\n    transform: translate(20px) scale(1, 1);\n  }\n\n  100% {\n    transform: translate(0) scale($ratio2, $ratio2);\n  }\n}\n","/**\n * ==============================================\n * Experimental: Gooey Effect\n * Dot Gathering\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$dot-color-hsl: hsl(0deg, 100%, 0%);\n\n$d: 50px;\n\n.dot-gathering {\n  position: relative;\n\n  @include mixins.dot(\n    $width: 12px,\n    $height: 12px,\n    $radius: 6px,\n    $bg-color: $dot-color-hsl,\n    $color: transparent\n  );\n\n  margin: -1px 0;\n  filter: blur(2px);\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: - $d;\n\n    @include mixins.dot(\n      $width: 12px,\n      $height: 12px,\n      $radius: 6px,\n      $bg-color: $dot-color-hsl,\n      $color: transparent\n    );\n\n    opacity: 0;\n    filter: blur(2px);\n    animation: dot-gathering 2s infinite ease-in;\n  }\n\n  &::after {\n    animation-delay: .5s;\n  }\n}\n\n@keyframes dot-gathering {\n  0% {\n    opacity: 0;\n    transform: translateX(0);\n  }\n\n  35%,\n  60% {\n    opacity: 1;\n    transform: translateX($d);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translateX($d * 2);\n  }\n}\n","/**\n * ==============================================\n * Experimental: Gooey Effect\n * Dot Hourglass\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$dot-color-hsl: hsl(0deg, 100%, 0%);\n\n$r: variables.$dot-spacing;\n$origin-x: variables.$dot-width * .5;\n$origin-y: variables.$dot-height * .5 + $r;\n\n.dot-hourglass {\n  position: relative;\n  top: -$r;\n\n  @include mixins.dot(\n    $width: 12px,\n    $height: 12px,\n    $radius: 6px,\n    $bg-color: $dot-color-hsl,\n    $color: transparent\n  );\n\n  margin: -1px 0;\n  filter: blur(2px);\n  transform-origin: $origin-x $origin-y;\n  animation: dot-hourglass 2.4s infinite ease-in-out;\n  animation-delay: .6s;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    @include mixins.dot(\n      $width: 12px,\n      $height: 12px,\n      $radius: 6px,\n      $bg-color: $dot-color-hsl,\n      $color: transparent\n    );\n\n    filter: blur(2px);\n  }\n\n  &::before {\n    top: $r + $r;\n  }\n\n  &::after {\n    animation: dot-hourglass-after 2.4s infinite cubic-bezier(.65, .05, .36, 1);\n  }\n}\n\n@keyframes dot-hourglass {\n  0% {\n    transform: rotateZ(0deg);\n  }\n\n  25% {\n    transform: rotateZ(180deg);\n  }\n\n  50% {\n    transform: rotateZ(180deg);\n  }\n\n  75% {\n    transform: rotateZ(360deg);\n  }\n\n  100% {\n    transform: rotateZ(360deg);\n  }\n}\n\n@keyframes dot-hourglass-after {\n  0% {\n    transform: translateY(0);\n  }\n\n  25% {\n    transform: translateY($r * 2);\n  }\n\n  50% {\n    transform: translateY($r * 2);\n  }\n\n  75% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n","/**\n * ==============================================\n * Experimental: Gooey Effect\n * Dot Overtaking\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$dot-color-hsl: hsl(0deg, 100%, 0%);\n\n.dot-overtaking {\n  position: relative;\n\n  @include mixins.dot(\n    $width: 12px,\n    $height: 12px,\n    $radius: 6px,\n    $bg-color: transparent,\n    $color: $dot-color-hsl\n  );\n\n  margin: -1px 0;\n  box-shadow: 0 -20px 0 0;\n  filter: blur(2px);\n  animation: dot-overtaking 2s infinite cubic-bezier(.2, .6, .8, .2);\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    @include mixins.dot(\n      $width: 12px,\n      $height: 12px,\n      $radius: 6px,\n      $bg-color: transparent,\n      $color: $dot-color-hsl\n    );\n\n    box-shadow: 0 -20px 0 0;\n    filter: blur(2px);\n  }\n\n  &::before {\n    animation: dot-overtaking 2s infinite cubic-bezier(.2, .6, .8, .2);\n    animation-delay: .3s;\n  }\n\n  &::after {\n    animation: dot-overtaking 1.5s infinite cubic-bezier(.2, .6, .8, .2);\n    animation-delay: .6s;\n  }\n}\n\n@keyframes dot-overtaking {\n  0% {\n    transform: rotateZ(0deg);\n  }\n\n  100% {\n    transform: rotateZ(360deg);\n  }\n}\n","/**\n * ==============================================\n * Experimental: Gooey Effect\n * Dot Shuttle\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$d: 3 * variables.$dot-spacing;\n$dot-color-hsl: hsl(0deg, 100%, 0%);\n\n.dot-shuttle {\n  position: relative;\n  left: - variables.$dot-spacing;\n\n  @include mixins.dot(\n    $width: 12px,\n    $height: 12px,\n    $radius: 6px,\n    $bg-color: $dot-color-hsl,\n    $color: transparent\n  );\n\n  margin: -1px 0;\n  filter: blur(2px);\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n\n    @include mixins.dot(\n      $width: 12px,\n      $height: 12px,\n      $radius: 6px,\n      $bg-color: $dot-color-hsl,\n      $color: transparent\n    );\n\n    filter: blur(2px);\n  }\n\n  &::before {\n    left: variables.$dot-spacing;\n    animation: dot-shuttle 2s infinite ease-out;\n  }\n\n  &::after {\n    left: 2 * variables.$dot-spacing;\n  }\n}\n\n@keyframes dot-shuttle {\n  0%,\n  50%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25% {\n    transform: translateX(- $d);\n  }\n\n  75% {\n    transform: translateX($d);\n  }\n}\n","/**\n * ==============================================\n * Experimental: Emoji\n * Dot Bouncing\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$d: 20px;\n\n.dot-bouncing {\n  position: relative;\n  height: variables.$dot-height;\n  font-size: 10px;\n\n  &::before {\n    content: '⚽🏀🏐';\n    display: inline-block;\n    position: relative;\n    animation: dot-bouncing 1s infinite;\n  }\n}\n\n@keyframes dot-bouncing {\n  0% {\n    top: - $d;\n    animation-timing-function: ease-in;\n  }\n\n  34% {\n    transform: scale(1, 1);\n  }\n\n  35% {\n    top: $d;\n    animation-timing-function: ease-out;\n    transform: scale(1.5, .5);\n  }\n\n  45% {\n    transform: scale(1, 1);\n  }\n\n  90% {\n    top: - $d;\n  }\n\n  100% {\n    top: - $d;\n  }\n}\n","/**\n * ==============================================\n * Experimental: Emoji\n * Dot Rolling\n * ==============================================\n */\n\n@use './variables';\n@use './mixins';\n\n$d: 20px;\n\n.dot-rolling {\n  position: relative;\n  height: variables.$dot-height;\n  font-size: 10px;\n\n  &::before {\n    content: '⚽';\n    display: inline-block;\n    position: relative;\n    transform: translateX(-25px);\n    animation: dot-rolling 3s infinite;\n  }\n}\n\n@keyframes dot-rolling {\n  0% {\n    content: '⚽';\n    transform: translateX(-25px) rotateZ(0deg);\n  }\n\n  16.667% {\n    content: '⚽';\n    transform: translateX(25px) rotateZ(720deg);\n  }\n\n  33.333% {\n    content: '⚽';\n    transform: translateX(-25px) rotateZ(0deg);\n  }\n\n  34.333% {\n    content: '🏀';\n    transform: translateX(-25px) rotateZ(0deg);\n  }\n\n  50% {\n    content: '🏀';\n    transform: translateX(25px) rotateZ(720deg);\n  }\n\n  66.667% {\n    content: '🏀';\n    transform: translateX(-25px) rotateZ(0deg);\n  }\n\n  67.667% {\n    content: '🏐';\n    transform: translateX(-25px) rotateZ(0deg);\n  }\n\n  83.333% {\n    content: '🏐';\n    transform: translateX(25px) rotateZ(720deg);\n  }\n\n  100% {\n    content: '🏐';\n    transform: translateX(-25px) rotateZ(0deg);\n  }\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
